import { Link } from "react-router-dom";
import { Instagram, Twitter, Mail } from "lucide-react";
import { SITE } from "../lib/site";

export default function Footer() {
  return (
    <footer className="mt-32 border-t border-[#c9a04b]/15 bg-charcoal">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-serif text-2xl text-cream mb-2">{SITE.brand}</div>
          <div className="eyebrow mb-5">{SITE.tagline}</div>
          <p className="text-sm text-cream/60 leading-relaxed max-w-md">
            London-based British erotic hypnotist. Discreet, consensual erotic hypnosis -
            in-person, recorded and remote. Every session is held with explicit
            consent, professionalism and tailored aftercare.
          </p>
          <div className="flex gap-4 mt-6">
            <a href="mailto:hello@queencleopatra.example" data-testid="footer-email" aria-label="Email" className="link-gold p-2 border border-[#c9a04b]/30 inline-flex"><Mail size={14} /></a>
            <a href="#" data-testid="footer-instagram" aria-label="Instagram" className="link-gold p-2 border border-[#c9a04b]/30 inline-flex"><Instagram size={14} /></a>
            <a href="#" data-testid="footer-twitter" aria-label="Twitter" className="link-gold p-2 border border-[#c9a04b]/30 inline-flex"><Twitter size={14} /></a>
          </div>
        </div>

        <div>
          <div className="eyebrow mb-4">Explore</div>
          <ul className="space-y-2 text-sm text-cream/70">
            <li><Link to="/services" className="hover:text-gold">Services</Link></li>
            <li><Link to="/book" className="hover:text-gold">Book a Session</Link></li>
            <li><Link to="/shop" className="hover:text-gold">Shop</Link></li>
            <li><Link to="/gallery" className="hover:text-gold">Gallery</Link></li>
            <li><Link to="/testimonials" className="hover:text-gold">Testimonials</Link></li>
            <li><Link to="/faq" className="hover:text-gold">FAQ</Link></li>
            <li><Link to="/blog" className="hover:text-gold">Journal</Link></li>
            <li><Link to="/about" className="hover:text-gold">About</Link></li>
            <li><Link to="/appreciation" className="hover:text-gold text-gold/90">Appreciation</Link></li>
            <li><Link to="/contact" className="hover:text-gold">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow mb-4">Legal</div>
          <ul className="space-y-2 text-sm text-cream/70">
            <li><Link to="/legal/terms" className="hover:text-gold">Terms &amp; Conditions</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-gold">Privacy Policy</Link></li>
            <li><Link to="/legal/refund" className="hover:text-gold">Refund Policy</Link></li>
            <li><Link to="/legal/age" className="hover:text-gold">Age Verification</Link></li>
            <li><Link to="/legal/release" className="hover:text-gold">Release Agreement</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#c9a04b]/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-6 flex flex-col md:flex-row gap-3 justify-between items-center text-xs text-cream/40">
          <div>© {new Date().getFullYear()} {SITE.brand}. All rights reserved.</div>
          <div className="uppercase tracking-[0.18em]">Adults 18+ · Consensual · Discreet</div>
        </div>
      </div>
    </footer>
  );
}
